import {
  font_family_weight_medium,
  font_family_weight_regular,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  @keyframes marcom-bin-card-arrow-enter {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }

    35% {
      transform: translateY(6px);
      opacity: 1;
    }

    52% {
      transform: translateY(-3px);
      opacity: 1;
    }

    66% {
      transform: translateY(2.5px);
      opacity: 1;
    }

    78% {
      transform: translateY(-1px);
      opacity: 1;
    }

    88% {
      transform: translateY(0.5px);
      opacity: 1;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes marcom-bin-card-arrow-bounce {
    0%,
    100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(6px);
    }
  }

  width: 100%;

  .MarcomBinCard-root {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .MarcomBinCard-description {
    position: relative;
    width: 100%;
    height: 36px;
    overflow: hidden;
  }

  .MarcomBinCard-descriptionText {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${font_family_weight_regular};
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: transparent;
    background-image: linear-gradient(90deg, #2563eb 0%, #0f766e 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .MarcomBinCard-cardSection {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    width: 100%;
  }

  .MarcomBinCard-cardWrapper {
    position: relative;
    width: 100%;
    max-width: 355px;
  }

  .MarcomBinCard-card {
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 16.5px;
    user-select: none;
    cursor: default;
    aspect-ratio: 85.6 / 54;
    transition: box-shadow 300ms;
  }

  .MarcomBinCard-card.is-hovered {
    box-shadow:
      0 16px 60px rgba(0, 0, 0, 0.2),
      0 4px 16px rgba(0, 0, 0, 0.1);
  }

  .MarcomBinCard-card:not(.is-hovered) {
    box-shadow:
      0 8px 40px rgba(0, 0, 0, 0.12),
      0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .MarcomBinCard-cardArt,
  .MarcomBinCard-layer,
  .MarcomBinCard-scrim,
  .MarcomBinCard-gloss {
    position: absolute;
    inset: 0;
  }

  .MarcomBinCard-cardArt {
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }

  .MarcomBinCard-scrim {
    pointer-events: none;
  }

  .MarcomBinCard-gloss {
    pointer-events: none;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.08) 0%,
      transparent 50%,
      rgba(0, 0, 0, 0.06) 100%
    );
  }

  .MarcomBinCard-topRow {
    position: absolute;
    top: 20px;
    left: 20.5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 315px;
  }

  .MarcomBinCard-chip {
    width: 29px;
    height: 21px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .MarcomBinCard-extendIcon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    object-fit: contain;
    filter: brightness(0) invert(1);
  }

  .MarcomBinCard-privacyNote,
  .MarcomBinCard-noMatchMessage {
    position: absolute;
    left: 20px;
    bottom: calc(50% - 9px);
    width: 315px;
    font-family: ${font_family_weight_regular};
    font-size: 11px;
    line-height: 15px;
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .MarcomBinCard-privacyNote {
    display: flex;
    align-items: flex-start;
    gap: 4px;
  }

  .MarcomBinCard-lockIcon {
    flex-shrink: 0;
    margin-top: 2px;
  }

  .MarcomBinCard-inputWrapper {
    position: absolute;
    top: calc(50% + 37px);
    left: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 315px;
    height: 40px;
    padding: 0 16px;
    border-radius: 8px;
    transform: translateY(-50%);
    transition: all 200ms;
  }

  .MarcomBinCard-inputWrapper.is-focused {
    border: 1px solid #ffffff;
    background: rgba(255, 255, 255, 0.6);
  }

  .MarcomBinCard-inputWrapper.is-hovered {
    border: 1px solid rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.4);
  }

  .MarcomBinCard-inputWrapper.is-populated {
    border: 1px solid transparent;
    background: rgba(255, 255, 255, 0.4);
  }

  .MarcomBinCard-inputWrapper.is-idle {
    border: 1px solid transparent;
    background: rgba(255, 255, 255, 0.2);
  }

  .MarcomBinCard-input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    font-family: monospace;
    font-size: 14px;
    line-height: 24px;
    transition: color 200ms;
  }

  .MarcomBinCard-input::placeholder {
    transition: color 200ms;
  }

  .MarcomBinCard-input.is-lightText {
    color: #ffffff;
  }

  .MarcomBinCard-input.is-lightText::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  .MarcomBinCard-input.is-darkText {
    color: #1e2c4c;
  }

  .MarcomBinCard-input.is-darkText::placeholder {
    color: rgba(30, 44, 76, 0.4);
  }

  .MarcomBinCard-counter {
    flex-shrink: 0;
    font-family: monospace;
    font-size: 8px;
    line-height: 8px;
    transition: color 200ms;
  }

  .MarcomBinCard-counter.is-lightText {
    color: #ffffff;
  }

  .MarcomBinCard-counter.is-darkText {
    color: rgba(30, 44, 76, 0.5);
  }

  .MarcomBinCard-cardTypeLabel,
  .MarcomBinCard-partnerPricingLabel {
    position: absolute;
    left: 20px;
    font-family: ${font_family_weight_regular};
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    color: #ffffff;
  }

  .MarcomBinCard-cardTypeLabel {
    top: 184px;
  }

  .MarcomBinCard-partnerPricingLabel {
    bottom: 20px;
  }

  .MarcomBinCard-partnerPricingLabel p,
  .MarcomBinCard-cardTypeLabel p {
    margin: 0;
  }

  .MarcomBinCard-partnerPricingLabel p + p {
    margin-top: 2px;
  }

  .MarcomBinCard-cardNumberRow {
    position: absolute;
    left: 20px;
    display: flex;
    align-items: center;
    width: 315px;
    height: 40px;
    padding-left: 16px;
    padding-right: 0;
    transform: translateY(-50%);
  }

  .MarcomBinCard-cardNumberRow.withInlineClear {
    justify-content: space-between;
  }

  .MarcomBinCard-cardNumberRow.withoutInlineClear {
    justify-content: flex-start;
  }

  .MarcomBinCard-cardNumber {
    margin: 0;
    font-family: monospace;
    font-size: 14px;
    line-height: 24px;
    white-space: pre;
    color: #ffffff;
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
  }

  .MarcomBinCard-inlineClearButton,
  .MarcomBinCard-floatingClearButton {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: background-color 150ms;
  }

  .MarcomBinCard-inlineClearButton {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.2);
  }

  .MarcomBinCard-inlineClearButton:hover {
    background: rgba(255, 255, 255, 0.35);
  }

  .MarcomBinCard-floatingClearButton {
    position: absolute;
    top: -14px;
    right: -14px;
    z-index: 10;
    width: 32px;
    height: 32px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.5);
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.18);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
  }

  .MarcomBinCard-floatingClearButton:hover {
    background: rgba(0, 0, 0, 0.7);
  }

  .MarcomBinCard-arrowSection {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
  }

  .MarcomBinCard-arrowLabel {
    font-family: ${font_family_weight_regular};
    font-size: 11px;
    line-height: 14px;
    color: #697080;
    transition: opacity 500ms;
  }

  .MarcomBinCard-differentCardLink {
    font-family: ${font_family_weight_medium};
    font-size: 12px;
    line-height: 20px;
    color: #697080;
    text-decoration: underline;
    text-underline-offset: 2px;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: color 150ms;
  }

  .MarcomBinCard-differentCardLink:hover {
    color: #4489f9;
  }
`
